<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">计价管理</el-breadcrumb-item>
            <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->

        <div style="margin-top: 20px; display: flex; flex-direction: row; ">
            <el-form ref="form" :model="form" label-width="180px" style="margin-right: 60px; border: 1px solid #999; padding: 20px; border-radius: 20px; ">
                <!-- <div style="font-weight: 600; margin-bottom: 20px;">舒适车-时实计价</div> -->
                <el-form-item label="取消订单抽成（%）：">
                    <el-input v-model="valuationList[0].value"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="setVariable(0)">保存</el-button>
                </el-form-item>
            </el-form>
            <el-form ref="form" :model="form" label-width="180px" style="margin-right: 60px; border: 1px solid #999; padding: 20px; border-radius: 20px; ">
                <!-- <div style="font-weight: 600; margin-bottom: 20px;">舒适车-时实计价</div> -->
                <el-form-item label="人员显示范围（公里）：">
                    <el-input v-model="valuationList[1].value"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="setVariable(1)">保存</el-button>
                </el-form-item>
            </el-form>
        </div>



    </div>
</template>

<script>
// 导入请求方法
import {
    getVariableList,
    setVariable
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
    data() {
        return {
            valuationList: []
        };
    },
    // 注册组件
    components: {
        Pagination,
    },

    /**
     * 数据发生改变
     */
    watch: {},

    /**
     * 创建完毕
     */
    created() {
        this.getVariableList()


    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        // 获取数据方法
        getVariableList() {
            getVariableList({type:1}).then((res) => {

                if (res.code == 200) {
                    var list = res.data.list;

       
                    this.valuationList = list;
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            });
        },

        setVariable(index) {


            var parameter = {
                id: this.valuationList[index].id,
                value: this.valuationList[index].value

            };


            setVariable(parameter).then((res) => {

                this.$message({
                    type: "info",
                    message: res.msg,
                });
            });
        },







    },
};
</script>

<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/terrace/Valuation.vue